<div class="modal-overlay task-details-overlay" (click)="onClose()">
  <div class="modal-content task-details-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>
        <fa-icon [icon]="faInfoCircle"></fa-icon>
        <span>{{ 'MODAL.TASK.DETAILS.TITLE' | translate }}</span>
      </h3>
      <button class="close-btn" (click)="onClose()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>
    <div class="modal-body">
      <div class="detail-row">
        <span class="detail-label">{{ 'TASK.DETAIL.ID' | translate }}:</span>
        <span class="detail-value">{{ task.id }}</span>
      </div>
      @if (task.function_name) {
      <div class="detail-row">
        <span class="detail-label">{{ 'TASK.DETAIL.NAME' | translate }}:</span>
        <span class="detail-value">{{ task.function_name }}</span>
      </div>
      }
      <div class="detail-row">
        <span class="detail-label">{{ 'TASK.DETAIL.STATUS' | translate }}:</span>
        <span class="detail-value status-badge" [ngClass]="getStatusClass(task.status)">
          <fa-icon [icon]="getStatusIcon(task.status)"></fa-icon>
          {{ task.status }}
        </span>
      </div>
      @if (task.user_email) {
      <div class="detail-row">
        <span class="detail-label">{{ 'TASK.DETAIL.USER' | translate }}:</span>
        <span class="detail-value">{{ task.user_email }}</span>
      </div>
      }
      @if (task.created_at) {
      <div class="detail-row">
        <span class="detail-label">{{ 'TASK.DETAIL.CREATED' | translate }}:</span>
        <span class="detail-value">{{ formatDate(task.created_at) }}</span>
      </div>
      }
      @if (task.enqueued_at) {
      <div class="detail-row">
        <span class="detail-label">{{ 'TASK.DETAIL.ENQUEUED' | translate }}:</span>
        <span class="detail-value">{{ formatDate(task.enqueued_at) }}</span>
      </div>
      }
      @if (task.ended_at) {
      <div class="detail-row">
        <span class="detail-label">{{ 'TASK.DETAIL.ENDED' | translate }}:</span>
        <span class="detail-value">{{ formatDate(task.ended_at) }}</span>
      </div>
      }
      @if (task.origin) {
      <div class="detail-row">
        <span class="detail-label">{{ 'TASK.DETAIL.ORIGIN' | translate }}:</span>
        <span class="detail-value">{{ task.origin }}</span>
      </div>
      }
      @if (task.result) {
      <div class="detail-row">
        <span class="detail-label">{{ 'TASK.DETAIL.RESULT' | translate }}:</span>
        <pre class="detail-code">{{ formatResult(task.result) }}</pre>
      </div>
      }
      @if (task.error) {
      <div class="detail-row error-row">
        <span class="detail-label">{{ 'TASK.DETAIL.ERROR' | translate }}:</span>
        <pre class="detail-error">{{ task.error }}</pre>
      </div>
      }
    </div>
  </div>
</div>
